import { useQuery } from "@tanstack/react-query";
import { Secim } from "@koclukpanel/ui";
import { alanlariGetir } from "./api";

/**
 * ÖĞRENCİNİN ALANI — F-PPL-05c
 *
 * Kayıt ve düzenleme ekranlarının İKİSİ de bunu kullanıyor: liste ve
 * "kullanımda değil" davranışı iki yerde ayrı yazılsaydı biri arşivli
 * alanı sessizce boşaltırdı.
 *
 * ================================================================
 * SEÇİLİ ALAN LİSTEDE YOKSA SESSİZCE BOŞALMIYOR
 * ================================================================
 * Liste yalnızca ETKİN alanları getiriyor. Öğrencinin alanı sonradan
 * pasifleşmişse `<select>` değeri listede bulamaz ve "Seçilmedi"
 * gösterirdi — kullanıcı alanın silindiğini sanır, kaydederse de
 * gerçekten silerdi. Mevcut alan ayrı bir seçenek olarak, durumu
 * yazılarak ekleniyor.
 */
export function AlanSecimi({
  deger,
  onChange,
  mevcut,
  hata,
}: {
  deger: string;
  onChange: (alanId: string) => void;
  /** Öğrencinin kayıtlı alanı — liste dışında kalmışsa da gösterilsin. */
  mevcut?: { id: string; ad: string } | null;
  hata?: string;
}) {
  const alanlar = useQuery({ queryKey: ["alanlar"], queryFn: alanlariGetir, retry: false });
  const liste = alanlar.data ?? [];
  const listedeYok = mevcut && !liste.some((a) => a.id === mevcut.id) ? mevcut : null;

  return (
    <Secim
      etiket="Alan"
      value={deger}
      onChange={(e) => onChange(e.target.value)}
      disabled={alanlar.isPending}
      hata={
        hata ??
        (alanlar.isError
          ? "Alan listesi okunamadı; bu, alan tanımlı olmadığı anlamına gelmez."
          : undefined)
      }
      yardim="Program ekranında ders listesi buna göre gelir. AYT alanında TYT dersleri de listelenir."
    >
      <option value="">Seçilmedi</option>
      {liste.map((a) => (
        <option key={a.id} value={a.id}>
          {a.name}
        </option>
      ))}
      {listedeYok && <option value={listedeYok.id}>{listedeYok.ad} (kullanımda değil)</option>}
    </Secim>
  );
}
